import { ApiResponse } from 'apisauce';

import { generateApiClient } from '../api';
import { getGeneralApiProblem } from '../api/api-problem';

const api = generateApiClient();

export const getCurrenciesApi = async (query?: any): Promise<any> => {
  try {
    api.setHeader('Accept-Language', ``);
    const response: ApiResponse<any> = await api.get(`currencies${query}`);
    if (!response.ok) {
      const problem: any = getGeneralApiProblem(response);
      if (problem) return problem;
    }
    const data = response.data;

    return { kind: 'ok', data: data };
  } catch (e) {
    return { kind: 'bad-data' };
  }
};
